/* Muscle Road "Shop by Vehicle" finder — a Year/Make/Model dropdown that runs a search for the chosen
   vehicle. Data: fitment-options.json (built by Shopify/build_fitment_index.py --push). "Find Parts"
   routes to native Shopify search results (?q=year+model). Shows on desktop (next to
   the search bar) AND mobile (a full-width bar under the header). Self-contained; safe to remove. */
(function () {
  if (window.__mrVS) return; window.__mrVS = 1;
  var OPT_URL_FINAL = (window.MR_FITMENT_OPTIONS || "");
  var RESULTS = "/search";   // native Shopify search (reads ?q=&type=product) -- was Rapid Search

  function css() {
    var s = document.createElement("style");
    s.textContent = [
      /* header breathing room (desktop) */
      "@media(min-width:990px){",
      "  .header__search-bar{gap:24px;padding-left:40px;padding-right:16px;align-items:center;}",
      "  .header__search-bar .search-modal__form--large{max-width:none;}",
      "  .header__heading-logo-wrapper{margin-right:22px;}",
      "  .header__icons{gap:1.4rem;}",
      "  .header__cta{margin-left:1.1rem;margin-right:1.4rem;}",
      "  .mrvs--desktop{margin:0 12px;}",
      "}",
      /* button */
      ".mrvs{position:relative;display:flex;align-items:center;flex:0 0 auto;}",
      ".mrvs__btn{display:inline-flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;",
      "white-space:nowrap;font-weight:700;font-size:1.05rem;color:inherit;background:transparent;",
      "border:2px solid currentColor;border-radius:10px;padding:13px 20px;line-height:1;opacity:.96;}",
      ".mrvs__btn:hover{opacity:1;}",
      ".mrvs__btn svg{width:24px;height:24px;fill:currentColor;flex:0 0 auto;}",
      /* dropdown panel */
      ".mrvs__panel{position:absolute;top:calc(100% + 10px);right:0;z-index:9999;width:480px;max-width:94vw;",
      "background:#fff;color:#1b2529;border-radius:12px;box-shadow:0 14px 40px rgba(0,0,0,.24);padding:26px;display:none;}",
      ".mrvs__panel.open{display:block;}",
      ".mrvs__panel h3{margin:0 0 18px;font-size:1.5rem;color:#1b2529;font-weight:700;}",
      ".mrvs__panel select{width:100%;padding:18px 16px !important;margin-bottom:18px;border:1px solid #ccc;",
      "border-radius:8px;font-size:1.5rem !important;line-height:1.3 !important;height:auto !important;",
      "background:#fff;color:#1b2529;font-weight:600;}",
      ".mrvs__panel select option{font-size:1.35rem;padding:10px;}",
      ".mrvs__panel select:disabled{background:#f2f2f2;color:#999;}",
      ".mrvs__go{width:100%;padding:17px;border:0;border-radius:8px;background:#da1414;color:#fff;",
      "font-weight:700;font-size:1.25rem;cursor:pointer;}",
      ".mrvs__go:disabled{background:#e6a1a1;cursor:not-allowed;}",
      ".mrvs__recent{margin-top:18px;font-size:1.2rem;}",
      ".mrvs__recent a{color:#0a58ca;text-decoration:none;font-weight:600;}",
      /* desktop-only instance */
      "@media(max-width:989px){.mrvs--desktop{display:none;}}",
      /* mobile-only instance: full-width bar under the header */
      ".mrvs--mobile{display:none;}",
      "@media(max-width:989px){",
      "  .mrvs--mobile{display:block;width:100%;background:#1b2529;}",
      "  .mrvs--mobile .mrvs__btn{display:flex;width:100%;color:#fff;border:0;border-radius:0;padding:15px;font-size:1.1rem;}",
      "  .mrvs--mobile .mrvs__panel{position:static;width:100%;max-width:100%;border-radius:0;box-shadow:none;",
      "    border-top:1px solid #eee;}",
      "}"
    ].join("");
    document.head.appendChild(s);
  }

  var CAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.9 6.6C18.7 6 18.1 5.6 17.5 5.6H6.5c-.6 0-1.2.4-1.4 1L3.5 11H3c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h1c0 1.1.9 2 2 2s2-.9 2-2h8c0 1.1.9 2 2 2s2-.9 2-2h1c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-.5l-1.6-4.4zM6.5 7.1h11l1.3 3.6H5.2L6.5 7.1zM6 16.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6zm12 0c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6z"/></svg>';

  function build(opt, variant) {
    var makes = opt.makes || {};
    var gLo = 9999, gHi = 0;
    Object.keys(makes).forEach(function (mk) {
      Object.keys(makes[mk]).forEach(function (md) {
        var r = makes[mk][md]; if (r) { gLo = Math.min(gLo, r[0]); gHi = Math.max(gHi, r[1]); }
      });
    });
    if (gLo > gHi) { gLo = 1940; gHi = (new Date()).getFullYear(); }

    var wrap = document.createElement("div"); wrap.className = "mrvs mrvs--" + variant;
    wrap.innerHTML =
      '<button type="button" class="mrvs__btn">' + CAR + 'Shop by Vehicle ▾</button>' +
      '<div class="mrvs__panel">' +
        '<h3>Find parts for your vehicle</h3>' +
        '<select class="mrvs__year"><option value="">Select Year</option></select>' +
        '<select class="mrvs__make"><option value="">Select Make</option></select>' +
        '<select class="mrvs__model" disabled><option value="">Select Model</option></select>' +
        '<button type="button" class="mrvs__go" disabled>Find Parts</button>' +
        '<div class="mrvs__recent"></div>' +
      '</div>';
    var btn = wrap.querySelector(".mrvs__btn"), panel = wrap.querySelector(".mrvs__panel");
    var yrSel = wrap.querySelector(".mrvs__year"), mkSel = wrap.querySelector(".mrvs__make");
    var mdSel = wrap.querySelector(".mrvs__model"), go = wrap.querySelector(".mrvs__go");
    var recent = wrap.querySelector(".mrvs__recent");

    for (var y = gHi; y >= gLo; y--) { var o = document.createElement("option"); o.value = y; o.textContent = y; yrSel.appendChild(o); }
    Object.keys(makes).sort().forEach(function (mk) { var o = document.createElement("option"); o.value = mk; o.textContent = mk; mkSel.appendChild(o); });

    function reset(sel, ph) { sel.innerHTML = '<option value="">' + ph + "</option>"; }
    function refreshGo() { go.disabled = !(mkSel.value && mdSel.value); }
    function fillModels() {
      reset(mdSel, "Select Model"); mdSel.disabled = !mkSel.value; refreshGo();
      if (!mkSel.value) return;
      var models = makes[mkSel.value] || {}, yr = parseInt(yrSel.value || "0", 10);
      Object.keys(models).filter(function (md) {
        if (!yr) return true; var r = models[md]; return !r || (r[0] <= yr && yr <= r[1]);
      }).sort(function (a, b) { if (a === "Other") return 1; if (b === "Other") return -1; return a.localeCompare(b); })
      .forEach(function (md) {
        var o = document.createElement("option"); o.value = md;
        o.textContent = md === "Other" ? "Other / Not listed" : md; mdSel.appendChild(o);
      });
    }
    yrSel.addEventListener("change", function () { if (mkSel.value) fillModels(); });
    mkSel.addEventListener("change", fillModels);
    mdSel.addEventListener("change", refreshGo);

    function urlFor(mk, md, y) {
      var parts = [];
      if (y) parts.push(y);
      if (md && md !== "Other") parts.push(md);   // model is the distinctive fitment term
      else if (mk) parts.push(mk);                 // "Other" model -> search by make instead
      return RESULTS + "?q=" + encodeURIComponent(parts.join(" ")) + "&type=product";
    }
    go.addEventListener("click", function () {
      if (go.disabled) return;
      try { localStorage.setItem("mrvs_recent", JSON.stringify({ mk: mkSel.value, md: mdSel.value, y: yrSel.value })); } catch (e) {}
      window.location.href = urlFor(mkSel.value, mdSel.value, yrSel.value);
    });
    try {
      var r = JSON.parse(localStorage.getItem("mrvs_recent") || "null");
      if (r && r.mk && r.md) {
        var lbl = [r.y || "", r.mk, r.md === "Other" ? "" : r.md].filter(Boolean).join(" ");
        recent.innerHTML = 'Recent: <a href="' + urlFor(r.mk, r.md, r.y) + '">' + lbl.replace(/</g, "&lt;") + "</a>";
      }
    } catch (e) {}
    btn.addEventListener("click", function (e) { e.stopPropagation(); panel.classList.toggle("open"); });
    panel.addEventListener("click", function (e) { e.stopPropagation(); });
    document.addEventListener("click", function () { panel.classList.remove("open"); });
    return wrap;
  }

  function inject(opt) {
    css();
    // desktop: next to the search bar
    var bar = document.querySelector(".header__search-bar");
    if (bar && !bar.querySelector(".mrvs--desktop")) bar.appendChild(build(opt, "desktop"));
    // mobile: full-width bar right under the header section
    if (!document.querySelector(".mrvs--mobile")) {
      var h = document.querySelector(".header");
      var sec = h && (h.closest(".shopify-section") || h.parentElement);
      if (sec && sec.parentNode) sec.parentNode.insertBefore(build(opt, "mobile"), sec.nextSibling);
    }
  }

  function boot() {
    if (!OPT_URL_FINAL) return;
    fetch(OPT_URL_FINAL).then(function (r) { return r.json(); }).then(function (opt) {
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { inject(opt); });
      else inject(opt);
    }).catch(function () {});
  }
  boot();
})();
